export default {
    journal: {
        list: {
            title: 'Journal',
            createNote: 'Add Note',
            noItems:
                'Start your journey now! Leave your first note or watch your first meditation!'
        }
    }
};
